import { CodeStep, PluginCodeStep } from '../actionSectionTypes';
import { INPUT_TYPES, OUTPUT_TYPES } from './constants';

export const codeStepRemoveVariable = (
  step: CodeStep | PluginCodeStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];
  const nextStep = { ...step };

  nextStep.details.inputs = nextStep.details.inputs.map((input) => {
    if (
      input.inputType === INPUT_TYPES.variable &&
      input.variable?.name === variableName
    ) {
      nextStep.hasError = true;
      if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
        nextErrorIds.push(step.id);
      }
      return {
        ...input,
        variable: { name: variableName, deleted: true },
      };
    }
    return input;
  });

  nextStep.details.outputs = nextStep.details.outputs.map((output) => {
    if (
      output.outputType === OUTPUT_TYPES.variable &&
      output.variable?.name === variableName
    ) {
      nextStep.hasError = true;
      if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
        nextErrorIds.push(step.id);
      }
      return {
        ...output,
        variable: { name: variableName, deleted: true },
      };
    }
    return output;
  });

  return {
    nextStep,
    nextErrorIds,
  };
};
